import { render } from "./Inovasi.vue?vue&type=template&id=43d8c072"
import script from "./Inovasi.vue?vue&type=script&lang=js"
export * from "./Inovasi.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__